import { mergeCartItems } from './cartIdentity';

export default {
  setStoreNo(state, storeNo) {
    state.storeNo = storeNo;
  },
  setCart(state, cart) {
    const mergedCart = mergeCartItems(cart);
    if (mergedCart.length > 0) state.cart = mergedCart;
    else {
      state.storeNo = 0;
      state.cart = [];
      state.ttl = -1;
    }
  },
  setTtl(state, ttl) {
    state.ttl = ttl;
  },
  purge(state) {
    state.storeNo = 0;
    state.cart = [];
    state.ttl = -1;
  }
};
